import React from 'react';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../../commonComponents/util/LoadingSpinner';
import { RecipientTypes, Departments } from '../../../../lib/systemVariables';

const initialState = {
    currentParticipantIndex: 0,
    currentParticipantId: null,
    newParticipants: {}
};

export default class WizardStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...initialState,
            currentParticipantId: props.addedParticipants[0] ? props.addedParticipants[0].externalListMemberId : initialState.currentParticipantId,
            newParticipants: this.getNewParticipants(props.newParticipants || [], props.rejectedParticipants || [])
        };
    }

    componentDidMount() {
        this.getRecipientSuggestionsBlacklist();
    }

    getNewParticipants(newParticipants, rejectedParticipants) {
        if (newParticipants.length === 0)
            return {}

        const p = {};
        const particiapnts = newParticipants.map(item => {
            const rejectedParticipant = rejectedParticipants.find(r => r.key.toString() === item.key.toString());
            p[item.key] = {};
            p[item.key]["createNew"] = item.value ? false : true;
            p[item.key]["suggestionId"] = item.value ? item.value : null;
            p[item.key]["suggestionName"] = item.name ? item.name : null;
            p[item.key]["suggestionLastName"] = item.lastName ? item.lastName : null;
            p[item.key]["suggestionPosition"] = item.orgEmployment ? item.orgEmployment : null; 
            p[item.key]["reject"] = !!rejectedParticipant ? true : false;
            p[item.key]["rejectedReason"] = !!rejectedParticipant ? rejectedParticipant.value : "";
            return p;
        })

        return p
    }

    getRecipientSuggestionsBlacklist = async () => {
        if (this.props.addedParticipants.length) {
            await this.props.getListRecipients();

            if (this.props.listRecipients.success) {
                this.getRecipientSuggestions();
            }
        }
    }

    componentWillUnmount() {
        this.setState(initialState);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.addedParticipants[0] && nextProps.addedParticipants[0] !== this.props.addedParticipants[0]) {
            this.setState({ currentParticipantId: nextProps.addedParticipants[0].externalListMemberId }, this.getRecipientSuggestions);
        }
    }

    setParticipants = () => {
        const updatedNewParticipants = [];
        const rejectedParticipants = [];

        for (var participantId in this.state.newParticipants) {
            updatedNewParticipants.push({
                key: participantId,
                value: this.state.newParticipants[participantId].suggestionId,
                name: this.state.newParticipants[participantId].suggestionName,
                lastName: this.state.newParticipants[participantId].suggestionLastName,
                orgEmployment: this.state.newParticipants[participantId].suggestionPosition
            });

            if (this.state.newParticipants[participantId].reject === true) {
                rejectedParticipants.push({
                    key: participantId,
                    value: this.state.newParticipants[participantId].rejectedReason,
                }); 
            }
        }
        
        this.props.updateNewParticipants(updatedNewParticipants);
        this.props.updateRejectedParticipants(rejectedParticipants);
    }

    onNext() {
        this.setParticipants();
        this.props.next();
    }
    
    onPrevious() {
        this.setParticipants();
        this.props.previous();
    }

    updateNewParticipant(participantId, state) {
        this.setState({
            newParticipants: { ...this.state.newParticipants, ...{ [participantId]: state } }
        });
    }

    toggleUseSuggestion(event) {
        this.updateNewParticipant(this.state.currentParticipantId, 
            { ...this.state.newParticipants[this.state.currentParticipantId], createNew: event.target.name === "create" ? true : false, suggestionId: null });
    }

    selectSuggestion(suggestionId, suggestionName, suggestionLastName, suggestionPosition) {
        this.updateNewParticipant(this.state.currentParticipantId, 
            { ...this.state.newParticipants[this.state.currentParticipantId], createNew: false, 
                suggestionId, suggestionName, suggestionLastName, suggestionPosition });
    }

    updateRejectParticipant(event) {
        this.updateNewParticipant(this.state.currentParticipantId, 
            { ...this.state.newParticipants[this.state.currentParticipantId],  reject: event.target.checked});
    }

    updateRejectedReason(event) {
        this.updateNewParticipant(this.state.currentParticipantId, 
            { ...this.state.newParticipants[this.state.currentParticipantId],  rejectedReason: event.target.value});

    }

    navigateParticipants(next) {
        if (next && (!this.state.newParticipants[this.state.currentParticipantId]
            || (!this.state.newParticipants[this.state.currentParticipantId].createNew && !this.state.newParticipants[this.state.currentParticipantId].suggestionId)))
            return;

        const updatedIndex = next ? this.state.currentParticipantIndex + 1 : this.state.currentParticipantIndex - 1;
        if (this.props.addedParticipants[updatedIndex]) {
            this.setState({
                currentParticipantIndex: updatedIndex,
                currentParticipantId: this.props.addedParticipants[updatedIndex].externalListMemberId
            }, this.getRecipientSuggestions);
        }
    }

    getRecipientSuggestions = async () => {
        const currentParticipant = this.props.addedParticipants[this.state.currentParticipantIndex];
        await this.props.getRecipientSuggestions(`${currentParticipant.firstName} ${currentParticipant.lastName}`,
            {
                address: currentParticipant.address,
                applicantType: RecipientTypes.Individual,
                departments: [this.props.isIsraeli ? Departments.IL : Departments.US],
                includeCampaignLists: true, //include campaign list field with results
                phoneNumber: currentParticipant.phoneNumber,
                ...(!this.props.isOrgList
                    ? { locationId: this.props.locationId }
                    : {})
            },
            [
                ...this.props.listRecipients.data,
                ...Object.keys(this.state.newParticipants)
                    .map(participantId => this.state.newParticipants[participantId].suggestionId && currentParticipant != participantId)
                    .filter(id => id)
            ]);
        if (!this.props.recipientSuggestions.data.filter(r => !r.incomplete).length)
            this.updateNewParticipant(this.state.currentParticipantId, { createNew: true, suggestionId: null, reject: false });
    }

    render() {
        const currentParticipant = this.props.addedParticipants[this.state.currentParticipantIndex] || {};
        const currentParticipantState = this.state.newParticipants[this.state.currentParticipantId] || { createNew: false, suggestionId: null, reject: false };
        const canChooseRecipientSuggestion = !!this.props.recipientSuggestions.data.filter(r => !r.incomplete).length;
        const {reject, rejectedReason } = currentParticipantState;

        return (
            <div className="wizard-step-2">
                {this.props.addedParticipants.length === 0
                    ? <span className="double-line-height">No participants have been added to this campaign list.  <br /> Click Next to continue.</span> :
                    <div>
                        <div className="modal-section">
                            <div className="flex new-staff">
                                <div>
                                    <label className="input-label">Reported New Staff</label>
                                    <p className="medium-text">{currentParticipant.displayName}</p>
                                </div>
                                <div>
                                    <label className="input-label">Previous Employment</label>
                                    <p className="medium-text">{currentParticipant.previousEmployment}</p>
                                </div>
                                {this.props.isOrgList &&
                                    <div>
                                        <label className="input-label">Current Employment</label>
                                        <p className="medium-text">{currentParticipant.orgEmployment || '---'}</p>
                                    </div>}
                                <div>
                                    <label className="input-label">Phone</label>
                                    {currentParticipant.phoneNumber && <p className="medium-text">{currentParticipant.phoneNumber.join(' | ') || '---'}</p>}
                                </div>
                                <div>
                                    <label className="input-label">Address</label>
                                    <p className="medium-text">{currentParticipant.addressDisplay}</p>
                                </div>
                                {currentParticipant.previousAddressDisplay && <div>
                                    <label className="input-label">Previous Address</label>
                                    <p className="medium-text">{currentParticipant.previousAddressDisplay}</p>
                                </div>}
                                <div>
                                    <label className="input-label">Email</label>
                                    <p className="medium-text">{currentParticipant.email || '---'}</p>
                                </div>
                            </div>
                            {this.props.isIsraeli && <div className="flex new-staff">
                                <div>
                                    <label className="input-label">Teudat Zehut</label>
                                    <p className="medium-text">{currentParticipant.teudatZahut}</p>
                                </div>
                                <div>
                                    <label className="input-label">Bank Number</label>
                                    <p className="medium-text">{currentParticipant.bankRoutingNumber}</p>
                                </div>
                                <div>
                                    <label className="input-label">Branch Number</label>
                                    <p className="medium-text">{currentParticipant.bankBranchNumber}</p>
                                </div>
                                <div>
                                    <label className="input-label">Account Number</label>
                                    <p className="medium-text">{currentParticipant.bankAccountNumber}</p>
                                </div>
                                <div>
                                    <label className="input-label">Account Holder</label>
                                    <p className="medium-text">{currentParticipant.bankAccountHolder || '---'}</p>
                                </div>
                            </div>}
                            <hr />
                        </div>

                        {
                            this.props.listRecipients.loading
                                ? <div className="text-center">
                                    <LoadingSpinner height={20} />
                                    <span className="small-text accent-text2">
                                        Retreiving recipient suggestion information...
                                    </span>
                                </div>
                                : !this.props.listRecipients.success
                                    ? <div className="modal-section">
                                        <span className="small-text error-text">
                                            Something went wrong when attempting to retrieve recipient suggestion information for this list.
                                            Please try refreshing the page.
                                        </span>
                                    </div>
                                    : <div className="modal-section relative suggestions-section">
                                        <input type="radio" id="suggestion" name="suggestion" disabled={!this.props.recipientSuggestions.loading && !canChooseRecipientSuggestion}
                                            checked={!currentParticipantState.createNew} onChange={this.toggleUseSuggestion.bind(this)} />
                                        <label htmlFor="suggestion" className={(!this.props.recipientSuggestions.loading && !canChooseRecipientSuggestion) ? "disabled" : ""}>
                                            Choose a suggestion
                                        </label>
                                        <span
                                            className="btn btn-xs btn-reset"
                                            onClick={this.getRecipientSuggestions}
                                        >
                                            <i className="icon-refresh"></i> Refresh
                                         </span>
                                        {
                                            this.props.recipientSuggestions.loading
                                                ? <LoadingSpinner height="25" />
                                                : (this.props.recipientSuggestions.data.length > 0 &&
                                                    <div className="table-container modal-table">
                                                        <table className="table">
                                                            <thead>
                                                                <tr className="table-header table-row">
                                                                    <th>Name</th>
                                                                    <th>Address</th>
                                                                    <th>Phone</th>
                                                                    <th>Campaign Lists</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.props.recipientSuggestions.data.map(recipient => <tr className="table-row" key={recipient.applicantId}>
                                                                    <td data-label="Name">
                                                                        <Link to={`/recipient-accounts/${recipient.applicantId}`}>
                                                                            {recipient.name}
                                                                        </Link>
                                                                        {recipient.incomplete &&
                                                                            <span className="tag incomplete">Incomplete</span>
                                                                        }
                                                                    </td>
                                                                    <td data-label="Address">
                                                                        <p>{recipient.address}</p>
                                                                    </td>
                                                                    <td data-label="Phone">
                                                                        <p>{recipient.phoneNumber}</p>
                                                                    </td>
                                                                    <td data-label="Campaign-Lists">
                                                                        <p>{recipient.campaignLists ? recipient.campaignLists.join(', ') : ''}</p>
                                                                    </td>
                                                                    <td className="use-btn-container">
                                                                        {!currentParticipantState.createNew && !recipient.incomplete &&
                                                                            <button className={`btn btn-flat btn-flat-open ${!currentParticipantState.createNew && currentParticipantState.suggestionId === recipient.applicantId ? "" : "btn-flat-open-hover"}`}
                                                                                onClick={this.selectSuggestion.bind(this, recipient.applicantId, recipient.name, recipient.lastName, recipient.orgEmployment)}> 
                                                                                <i className="icon-check icon-left"></i>Use
                                                                            </button>
                                                                        }
                                                                    </td>
                                                                </tr>)}
                                                            </tbody>
                                                        </table>
                                                    </div>)
                                        }
                                        <div className="radio-container">
                                            <input
                                                type="radio"
                                                id="create"
                                                name="create"
                                                checked={currentParticipantState.createNew}
                                                onChange={this.toggleUseSuggestion.bind(this)} />
                                            <label htmlFor="create">{this.props.recipientSuggestions.data.length ? "None of the above recipients match, c" : "C"}reate new recipient with info provided.</label>
                                        </div>
                                        <div className="info-row">                                           
                                            <div className="custom-check-container">
                                                <input type="checkbox" id="reject" name="reject" className="custom-check"
                                                    checked={currentParticipantState.reject}
                                                    onChange={this.updateRejectParticipant.bind(this)} />
                                                <label htmlFor="reject">Reject Application</label>
                                            </div>
                                            {reject && (<div className="column-half">
                                                <input type="text" placeholder="Reject Reason"
                                                    value={rejectedReason}
                                                    onChange={this.updateRejectedReason.bind(this)} />
                                            </div>)}
                                        </div>
                                        <hr />
                                        <p>
                                            <i className={`icon ion-ios-arrow-left icon-left primary-hover 
                            ${this.state.currentParticipantIndex === 0 ? "disabled" : ""}`}
                                                onClick={this.navigateParticipants.bind(this, false)}></i>
                                            {this.state.currentParticipantIndex + 1} of {this.props.addedParticipants.length}
                                            <i className={`icon ion-ios-arrow-right icon-right primary-hover
                            ${(this.state.currentParticipantIndex >= this.props.addedParticipants.length - 1 || (!currentParticipantState.createNew && !currentParticipantState.suggestionId)) ? "disabled" : ""}`}
                                                onClick={this.navigateParticipants.bind(this, true)}></i>
                                        </p>
                                        <hr />
                                    </div>
                        }
                    </div>}
                <div className="modal-btns text-right">
                    <button className="btn btn-primary" onClick={this.onPrevious.bind(this)}>Previous</button>
                    <button className="btn btn-accent" onClick={this.props.close}>Cancel</button>
                    <button className="btn btn-primary" onClick={this.onNext.bind(this)}
                        disabled={this.props.addedParticipants.length &&
                            ((!currentParticipantState.createNew && !currentParticipantState.suggestionId) || (Object.keys(this.state.newParticipants).length < this.props.addedParticipants.length))}>Next</button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/VerifyCampaignListWizard/WizardStep2.jsx